export default function releaseProductsDirective() {
  return {
    template: require('./release-products.html'),
    controller: 'ReleaseProductsController',
    controllerAs: 'releaseProductsVM',
    bindToController: true,
    replace: true,
  };
}
